import { NAME } from './constants';

export const SET_FEEDBACK = `${NAME}/SET_FEEDBACK`;
export const REVERT_FEEDBACK = `${NAME}/REVERT_FEEDBACK`;
export const RESET_FEEDBACKS = `${NAME}/RESET_FEEDBACKS`;
export const UPDATE_SEMAPHORE_RECORD = `${NAME}/UPDATE_SEMAPHORE_RECORD`;

export const APPEND_SEMAPHORE_LIST = `${NAME}/APPEND_SEMAPHORE_LIST`;
export const SET_SEMAPHORE_LIST = `${NAME}/SET_SEMAPHORE_LIST`;
export const SET_SEMAPHORE_DASHBOARD = `${NAME}/SET_SEMAPHORE_DASHBOARD`;
export const RESET_REDUCER = `${NAME}/RESET_REDUCER`;
